import "./reports-highlights-block.scss";